<main>
  <div class="container">

    <div class="row mb-4">
      <div class="col general-title">
        <h2>Histórico de Movimentações</h2>
      </div>
    </div>

    <div class="filters pt-2 pt-lg-4 pl-2 pl-lg-4 pb-3 pb-lg-5">
      <div class="row w-100" [formGroup]="formFiltro">

        <div class="col-auto mr-3 mb-2 mb-lg-0">
          <label for="data_inicio">Status</label>
          <select name="ordernar" id="ordernar" formControlName="movStatus" (change)="listar()" [disabled]="loading">
            <option disabled value="0">Status</option>
            <option selected value="">Todos</option>
            @for (dtIni of listStatusMov; track dtIni) {
              <option  value="{{dtIni.DCR_PART_MOV_STATUS_EXTERNO}}">{{dtIni.DCR_PART_MOV_STATUS_EXTERNO}}</option>
            }
          </select>
        </div>
        <div class="col-auto mr-3 mb-2 mb-lg-0">
          <label for="tipo_fundo">Tipo</label>
          <select name="tipo_fundo" id="tipo_fundo" formControlName="tipoFundo" (change)="listar()" [disabled]="loading" style="max-width: 120px;">
            <option  disabled selected value="0">Tipo</option>
            @for (item of tiposFundos; track item) {
              <option [value]="item.COD_FUNDO">{{item.DCR_FUNDO}}</option>
            }
          </select>
        </div>
        <div class="col-auto mr-3 mb-2 mb-lg-0">
          <label for="data_inicio">De</label>
          <select name="data_inicio"  formControlName="anomesInicio" [disabled]="loading">
            <option disabled selected value="0">Data início</option>
            @for (dtIni of listPrimeiroAnoMes; track dtIni) {
              <option  value="{{dtIni.ANOMES}}">{{dtIni.ANOMES_FORMATADO}}</option>
            }
          </select>
        </div>
        <div class="col-auto mr-3 mb-2 mb-lg-0">
          <label for="data_fim">Até</label>
          <select name="data_fim" formControlName="anomesFim" [disabled]="loading" (change)="listar()">
            <option disabled selected value="0">Data fim</option>
            @for (dtFim of listUltimoAnoMes; track dtFim) {
              <option value="{{dtFim.ANOMES}}">{{dtFim.ANOMES_FORMATADO}}</option>
            }
          </select>
        </div>
        <div class="col-auto mr-auto mb-2 mb-lg-0">
          <select name="ordernar" id="ordernar" formControlName="tipoOrdem" [disabled]="loading" (change)="listar()">
            <option selected disabled value="0">Ordenar por</option>
            <option value="1">Data</option>
            <option value="2">Valor</option>
          </select>
        </div>
        <div class="col-auto divbtnFiltro">
          <button class="btn btn-success" (click)="listar()" [disabled]="loading"><i class="fa fa-filter"></i> Filtrar</button>
        </div>
        <div class="col-auto divbtnExportar">
          <button class="btn btn-extract"(click)="print()" [disabled]="loading"><i class="fa fa-print"></i> Emitir Extrato</button>
        </div>

      </div>
    </div>

    <div class="box table-responsive mb-4">
      <table class="table table-borderless table-hover">
        <thead>
          <tr>
            <th class="text-center">Status</th>
            <th class="text-center">Cod. Cobrança</th>
            <th class="text-center">Referência</th>
            <th class="text-center">Valor</th>
            <th class="text-center">Vencimento</th>
            <th class="text-center">Valor Pago</th>
            <th class="text-center">Data Pagamento</th>
            <th class="text-center qntcotas">Quantidade de Cotas</th>
            <th class="text-center">Tipo</th>
          </tr>
        </thead>
        <tbody>
          @for (item of movimentacoes | paginate: { itemsPerPage: qntPorPage, currentPage: paginaAtual }; track item) {
            <tr>
              <td class="text-left {{item.CLASSE}}"><i class="fas fa-circle"></i>{{item.DCR_PART_MOV_STATUS_EXTERNO}}</td>
              <td class="text-center">{{item.COD_COBRANCA}}</td>
              <td class="text-center">{{item.DCR_ANOMES_REF}}</td>
              <td class="text-center">{{item.VLR_VENC| currency:'R$'}}</td>
              <td class="text-center">{{item.DTA_VENC| date:'dd/MM/yyyy'}}</td>
              <td class="text-center">{{item.VLR_PGTO| currency:'R$'}}</td>
              <td class="text-center">{{item.DTA_PGTO| date:'dd/MM/yyyy'}}</td>
              <td class="text-center">{{item.NUM_COTA| number:'1.12'}}</td>
              <td class="text-center type">{{item.DCR_MOV}}</td>
            </tr>
          }
        </tbody>
      </table>
    </div>
    <div class="col-md-12  text-right">
      <pagination-controls (pageChange)="paginaAtual = $event" previousLabel="Anterior" nextLabel="Próximo"></pagination-controls>
    </div>

  </div>

</main>